import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../api";
import recommandedIcon from "../assets/icons/reccomnadedIocn.png";
import popularIcon from "../assets/icons/popularIocn.png";
import addIcon from "../assets/icons/addIcon1.png";
import "../css/EnterpriseDetails.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CustomDateInput } from "../utils/formatDate";
import changeStatusIcon from "../assets/Images/ChangeStatus.png";
import editIcon from "../assets/Images/Edit.png";
import cpyIcon from "../assets/icons/Copy.png";
import crossIcon from "../assets/icons/crossIcon.png";
import { toast } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import { formatDateToUserTimeZone } from "../utils/formatDate";
import Cropper from "react-easy-crop";
import getCroppedImg from "../utils/cropImage";

const API_BASE = process.env.REACT_APP_API_URL;

const colorTemplates = [
  {
    id: "template1",
    name: "Quantum Midnight (FUI)",
    colors: {
      slide_background: "#0B0E14", // Deep space charcoal
      header_color: "#E2E8F0",
      accent_color: "#00F2FF", // High-tech cyan neon
      right_card_bg: "#1A1F2B",
      right_card_row_odd: "#242C3D",
      right_card_row_even: "#1A1F2B",
      right_card_title_clr: "#FFFFFF",
      right_card_label_clr: "#94A3B8",
      right_card_value_clr: "#00F2FF",
      right_card_link_clr: "#7DD3FC",
      na_yellow: "#FDE047",
      text_dark: "#F1F5F9",
      text_mid: "#94A1B8",
      text_gray: "#64748B",
      blue_link: "#38BDF8",
      navy: "#1A1F2B",
      navy_mid: "#242C3D",
      navy_light: "#334155",
      custom_blue: "#00F2FF",
      white: "#FFFFFF",
      light_bg: "#111827",
    },
  },
  {
    id: "template2",
    name: "Clinical Infrastructure",
    colors: {
      slide_background: "#F8FAFC", // Professional soft ice
      header_color: "#0F172A",
      accent_color: "#10B981", // Healthcare Emerald
      right_card_bg: "#1E293B",
      right_card_row_odd: "#334155",
      right_card_row_even: "#1E293B",
      right_card_title_clr: "#FFFFFF",
      right_card_label_clr: "#CBD5E1",
      right_card_value_clr: "#34D399",
      right_card_link_clr: "#6EE7B7",
      na_yellow: "#FACC15",
      text_dark: "#0F172A",
      text_mid: "#475569",
      text_gray: "#94A1B8",
      blue_link: "#2563EB",
      navy: "#0F172A",
      navy_mid: "#1E293B",
      navy_light: "#334155",
      custom_blue: "#059669",
      white: "#FFFFFF",
      light_bg: "#F1F5F9",
    },
  },
  {
    id: "template3",
    name: "Obsidian Executive",
    colors: {
      slide_background: "#121212", // Premium Matte Black
      header_color: "#FFFFFF",
      accent_color: "#D4AF37", // Metallic Gold
      right_card_bg: "#1E1E1E",
      right_card_row_odd: "#2D2D2D",
      right_card_row_even: "#1E1E1E",
      right_card_title_clr: "#FFFFFF",
      right_card_label_clr: "#A3A3A3",
      right_card_value_clr: "#D4AF37",
      right_card_link_clr: "#FDE047",
      na_yellow: "#F59E0B",
      text_dark: "#F5F5F5",
      text_mid: "#A3A3A3",
      text_gray: "#737373",
      blue_link: "#D4AF37",
      navy: "#121212",
      navy_mid: "#1E1E1E",
      navy_light: "#262626",
      custom_blue: "#404040",
      white: "#FFFFFF",
      light_bg: "#171717",
    },
  },
  {
    id: "template4",
    name: "Electric Blueprint",
    colors: {
      slide_background: "#0F172A", // Engineering Navy
      header_color: "#38BDF8",
      accent_color: "#818CF8", // Indigo Glow
      right_card_bg: "#1E293B",
      right_card_row_odd: "#334155",
      right_card_row_even: "#1E293B",
      right_card_title_clr: "#F8FAFC",
      right_card_label_clr: "#94A1B8",
      right_card_value_clr: "#BAE6FD",
      right_card_link_clr: "#7DD3FC",
      na_yellow: "#FCD34D",
      text_dark: "#F8FAFC",
      text_mid: "#94A1B8",
      text_gray: "#64748B",
      blue_link: "#0EA5E9",
      navy: "#0F172A",
      navy_mid: "#1E293B",
      navy_light: "#334155",
      custom_blue: "#38BDF8",
      white: "#FFFFFF",
      light_bg: "#1E293B",
    },
  },
  {
    id: "template5",
    name: "Silicon Valley White",
    colors: {
      slide_background: "#FFFFFF", // Clean modern minimalist
      header_color: "#334155",
      accent_color: "#6366F1", // Modern Software Violet
      right_card_bg: "#F1F5F9",
      right_card_row_odd: "#E2E8F0",
      right_card_row_even: "#F1F5F9",
      right_card_title_clr: "#1E293B",
      right_card_label_clr: "#64748B",
      right_card_value_clr: "#4F46E5",
      right_card_link_clr: "#818CF8",
      na_yellow: "#FBBF24",
      text_dark: "#1E293B",
      text_mid: "#64748B",
      text_gray: "#94A1B8",
      blue_link: "#4F46E5",
      navy: "#334155",
      navy_mid: "#475569",
      navy_light: "#94A1B8",
      custom_blue: "#6366F1",
      white: "#FFFFFF",
      light_bg: "#F8FAFC",
    },
  },
];

const defaultThemeSettings = {
  enterprise_name: "",
  logo_path: "",
  logo_key: "",
  enable_logo: true,
  slide_background: "#FFFFFF",
  header_color: "#003374",
  accent_color: "#2F83F6",
  right_card_bg: "#003374",
  right_card_row_odd: "#034889",
  right_card_row_even: "#003374",
  right_card_title_clr: "#FFFFFF",
  right_card_label_clr: "#FFFFFF",
  right_card_value_clr: "#D0E4FF",
  right_card_link_clr: "#ADD8FF",
  na_yellow: "#FFE599",
  text_dark: "#0F172A",
  text_mid: "#475569",
  text_gray: "#94A1B8",
  blue_link: "#2563EB",
  navy: "#003A78",
  navy_mid: "#0A4A92",
  navy_light: "#3769A8",
  custom_blue: "#156082",
  white: "#FFFFFF",
  light_bg: "#F8FAFC",
  primary_font: "Calibri",
  header_font: "Calibri",
  footer_font: "Calibri",
  footer_font_size: 9,
  confidential_text: "Confidential  |  2026",
  enable_footer: true,
  enable_confidential: true,
};

const EnterpriseSettings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const enterprise = location.state?.enterprise;

  const [showSubscription, setShowSubscription] = useState(true);
  const [showOrganization, setShowOrganization] = useState(true);
  const [showDisclaimer, setShowDisclaimer] = useState(true);
  const [showModelSettings, setShowModelSettings] = useState(true);
  const [existingModelSettings, setExistingModelSettings] = useState([]);
  const [isModelSettingsFetched, setIsModelSettingsFetched] = useState(false);
  const [showDocumentation, setShowDocumentation] = useState(true);
  const [documentation, setDocumentation] = useState({
    auto_approve: false,
  });
  const [hasDocId, setHasDocId] = useState(false); // For backend check
  const [isValidating, setIsValidating] = useState(false);
  const [modelSettings, setModelSettings] = useState({
    recommended_models: [],
    popular_models: [],
  });

  const [showTemplateSettings, setShowTemplateSettings] = useState(true);
  const [themeSettings, setThemeSettings] = useState(defaultThemeSettings);

  const [availableModels, setAvailableModels] = useState([]);

  const [showApiModal, setShowApiModal] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState("OpenAI");
  const [apiKey, setApiKey] = useState("");
  const [apiNotes, setApiNotes] = useState("");
  const [apiKeys, setApiKeys] = useState([]);
  const [editingRecord, setEditingRecord] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState("template1");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoadingTheme, setIsLoadingTheme] = useState(false);
  const [isProcessingLogo, setIsProcessingLogo] = useState(false);

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const fetchModels = async () => {
    try {
      console.log("🔹 Fetching available models...");
      const res = await api.get(
        `${API_BASE}/enterprise-model-settings/enterprise-active-model-settings`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      console.log("📌 Available models API response:", res.data);

      const available = res.data.data.filter(
        (item) =>
          item.model_details && // ✅ prevent null
          item.model_details.server_status === true && // ✅ prevent inactive server
          item.model_details.model_download_status === "1" &&
          item.model_details.model_status === "Approved",
      );

      console.log("🎯 Filtered available models:", available);

      setAvailableModels(available);
    } catch (err) {
      console.error("❌ Error fetching available models:", err);
      showErrorToast(TOAST_MESSAGES.MODEL.FETCH_ERROR);
    }
  };

  const fetchApiKeys = async () => {
    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    const enterpriseFid = enterprise?.enterprise_id;

    // ✅ Ensure token and enterprise ID exist
    if (!token || !enterpriseFid) {
      console.warn("Token or enterprise ID missing, cannot fetch API keys");
      return;
    }

    try {
      const res = await api.get(`${API_BASE}/enterprise-api-keys`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { enterprise_fid: enterpriseFid }, // pass enterprise ID
      });

      // ✅ Log cleanly for debugging
      console.log("Fetched API keys:", res.data);

      // ✅ Update state safely
      setApiKeys(res.data || []);
    } catch (err) {
      console.error("❌ Failed to fetch API keys:", err);
      showErrorToast("Failed to fetch API keys");
    }
  };

  // 1️⃣ Fetch available models
  useEffect(() => {
    fetchModels();
    fetchApiKeys();
  }, []);

  // 2️⃣ Fetch existing enterprise model settings
  useEffect(() => {
    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");
    if (!token || !enterprise?.enterprise_id) return;

    const fetchSettings = async () => {
      try {
        console.log("🔹 Fetching existing enterprise model settings...");
        const res = await api.get(
          `${API_BASE}/enterprise-admin-setting/byEnterprise/${enterprise.enterprise_id}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        console.log("📌 Existing model settings API response:", res.data);

        setExistingModelSettings(res.data || []);
        setIsModelSettingsFetched(true);
      } catch (err) {
        console.error("❌ Error fetching existing settings:", err);
      }
    };

    fetchSettings();
  }, [enterprise]);

  // 3️⃣ Combine available models and existing settings
  useEffect(() => {
    console.log("🔄 Combining models after both APIs fetched...");
    console.log("Available models:", availableModels);
    console.log("Existing model settings:", existingModelSettings);
    console.log("Is settings fetched?", isModelSettingsFetched);

    if (!availableModels.length || !isModelSettingsFetched) return;

    const recommendedModelsFromDB = existingModelSettings
      .filter((item) => item.enterprise_user_model_setting_status == "1")
      .map((item) => item.model_fid?.trim()) // use model_fid
      .filter(Boolean);

    console.log("recommanded model from db ", recommendedModelsFromDB);

    setModelSettings((prev) => ({
      ...prev,
      recommended_models: recommendedModelsFromDB,
    }));
  }, [availableModels, existingModelSettings, isModelSettingsFetched]);

  const [subscription, setSubscription] = useState({
    enterprise_subscription_name: "",
    enterprise_subscription_duration: "",
    enterprise_subscription_prize: "",
    enterprise_subscription_start_date: "",
    enterprise_subscription_end_date: "",
  });

  const [organization, setOrganization] = useState({
    enterprise_organisation_settings_theme: "",
    can_admin_view_chat: "",
    can_power_user_view_chat: "",
    data_retention_period: "",
    allowed_doc_size_mb: "",
    training_frequency: "",
    enterprise_organisation_settings_selected_model: "",
  });

  const [disclaimer, setDisclaimer] = useState({
    enterprise_disclaimer_title: "",
    enterprise_disclaimer_display_location: "",
    enterprise_disclaimer_description: "",
  });

  const [hasSubId, setHasSubId] = useState(false);
  const [hasOrgId, setHasOrgId] = useState(false);
  const [hasDisId, setHasDisId] = useState(false);

  const handleInput = (setter, key) => (e) =>
    setter((prev) => ({ ...prev, [key]: e.target.value }));

  useEffect(() => {
    const id = enterprise?.enterprise_id;
    if (!id) return;

    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");
    const headers = { Authorization: `Bearer ${token}` };

    api
      .get(`${API_BASE}/enterprise-subscriptions/byEnterprise/${id}`, {
        headers,
      })
      .then((res) => {
        if (res.data) {
          setHasSubId(true);
          setSubscription(res.data);
        }
      })
      .catch((err) => {
        console.error("Fetch subscription failed", err);
      });

    api
      .get(`${API_BASE}/enterprise-organisation-settings/byEnterprise/${id}`, {
        headers,
      })
      .then((res) => {
        if (res.data) {
          setHasOrgId(true);
          setOrganization(res.data);
        }
      })
      .catch((err) => {
        console.error("Fetch organization settings failed", err);
      });

    // api
    //   .get(`${API_BASE}/enterprise-disclaimer/byEnterprise/${id}`, {
    //     headers,
    //   })
    //   .then((res) => {
    //     if (res.data) {
    //       setHasDisId(true);
    //       setDisclaimer(res.data);
    //     }
    //   })
    //   .catch((err) => {
    //     console.error("Fetch disclaimer failed", err);
    //   });

    api
      .get(`${API_BASE}/enterprise-document-settings/byEnterprise/${id}`, {
        headers,
      })
      .then((res) => {
        if (res.data) {
          setHasDocId(true);
          setDocumentation(res.data);
        }
      })
      .catch((err) => {
        console.error("Fetch documentation settings failed", err);
      });

    setIsLoadingTheme(true);
    api
      .get(`${API_BASE}/theme/${id}`, {
        headers,
      })
      .then((res) => {
        setIsLoadingTheme(false);
        if (res.data) {
          setThemeSettings(res.data);
          // Set initial template if colors match
          const matchedTemplate = colorTemplates.find(
            (t) =>
              t.colors.header_color === res.data.header_color &&
              t.colors.accent_color === res.data.accent_color,
          );
          if (matchedTemplate) setSelectedTemplate(matchedTemplate.id);

          if (res.data.logo_path) {
            const path = res.data.logo_path;
            if (path.startsWith("http")) {
              setLogoPreviewUrl(path);
            } else {
              setLogoPreviewUrl(
                `${process.env.REACT_APP_SERVER_URL}/${path.replace(/\\/g, "/")}`,
              );
            }
          }
        }
      })
      .catch((err) => {
        setIsLoadingTheme(false);
        console.error("❌ Fetch theme settings failed:", err);
      });
  }, [enterprise]);

  const handleSave = async () => {
    if (isSaving) return;
    setIsSaving(true);
    const id = enterprise?.enterprise_id;

    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    const headers = { Authorization: `Bearer ${token}` };

    try {
      // === Subscription ===
      if (hasSubId) {
        await api.put(
          `${API_BASE}/enterprise-subscriptions/byEnterprise/${id}`,
          { ...subscription, enterprise_fid: id },
          { headers },
        );
      } else {
        await api.post(
          `${API_BASE}/enterprise-subscriptions`,
          { ...subscription, enterprise_fid: id },
          { headers },
        );
      }

      // === Organization ===
      if (hasOrgId) {
        await api.put(
          `${API_BASE}/enterprise-organisation-settings/byEnterprise/${id}`,
          { ...organization, enterprise_fid: id },
          { headers },
        );
      } else {
        await api.post(
          `${API_BASE}/enterprise-organisation-settings`,
          { ...organization, enterprise_fid: id },
          { headers },
        );
      }

      // === Documentation Settings ===
      if (hasDocId) {
        await api.put(
          `${API_BASE}/enterprise-document-settings/byEnterprise/${id}`,
          { ...documentation, enterprise_fid: id },
          { headers },
        );
      } else {
        await api.post(
          `${API_BASE}/enterprise-document-settings`,
          { ...documentation, enterprise_fid: id },
          { headers },
        );
      }

      // === Theme Settings ===
      // Auto-set enterprise name
      const updatedThemeSettings = {
        ...themeSettings,
        enterprise_name: enterprise?.enterprise_name || "",
      };

      // Handle logo upload if file selected
      if (logoFile) {
        const formData = new FormData();
        formData.append("logo", logoFile);
        formData.append("enterprise_id", id);

        const uploadRes = await api.post(
          `${API_BASE}/theme/upload-logo`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );

        updatedThemeSettings.logo_path = uploadRes.data.logo_path;
        updatedThemeSettings.logo_key = uploadRes.data.logo_key;
      }

      await api.put(
        `${API_BASE}/theme/${id}`,
        { ...updatedThemeSettings, enterprise_id: id },
        { headers },
      );

      // === Model Settings ===
      const modelSettingPayloads = [];
      const processedModelIds = new Set();

      modelSettings.recommended_models.forEach((modelName) => {
        const foundModel = availableModels.find(
          (m) => m.model_details?.model_name === modelName,
        );
        if (!foundModel) return;

        const modelId = foundModel.model_details.model_id;
        processedModelIds.add(modelId);

        const existing = existingModelSettings.find(
          (ems) => ems.model_fid === modelId,
        );

        if (existing) {
          modelSettingPayloads.push(
            api.put(
              `${API_BASE}/enterprise-admin-setting/byEnterprise/${id}`,
              { model_fid: modelId, enterprise_model_setting_status: "1" },
              { headers },
            ),
          );
        } else {
          modelSettingPayloads.push(
            api.post(
              `${API_BASE}/enterprise-admin-setting`,
              {
                enterprise_fid: id,
                model_fid: modelId,
                enterprise_model_setting_status: "1",
              },
              { headers },
            ),
          );
        }
      });

      existingModelSettings.forEach((existing) => {
        if (!processedModelIds.has(existing.model_fid)) {
          modelSettingPayloads.push(
            api.put(
              `${API_BASE}/enterprise-admin-setting/byEnterprise/${id}`,
              {
                model_fid: existing.model_fid,
                enterprise_model_setting_status: "0",
              },
              { headers },
            ),
          );
        }
      });

      if (modelSettingPayloads.length > 0) {
        await Promise.all(modelSettingPayloads);
      }

      showSuccessToast(TOAST_MESSAGES.ENTERPRISE_SETTINGS.SAVE_SUCCESS);
      setTimeout(() => navigate(-1), 1200);
    } catch (err) {
      console.error("Save failed:", err);
      showErrorToast(TOAST_MESSAGES.ENTERPRISE_SETTINGS.SAVE_ERROR);
    }
  };

  const handleReset = () => {
    setThemeSettings(defaultThemeSettings);
    setLogoFile(null); // Also reset the logo file
  };

  const handleValidateApi = async () => {
    const enterprise_fid = enterprise?.enterprise_id;
    if (!apiKey.trim()) return showErrorToast("API Key is required!");
    if (!selectedProvider) return showErrorToast("Please select a provider!");

    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    try {
      setIsValidating(true);

      /* ===============================
       1️⃣ STEP 1: VALIDATE API KEY
    =============================== */
      const validateRes = await api.post(
        `${process.env.REACT_APP_API_URL}/enterprise-model-settings/validate-and-assign`,
        {
          provider: selectedProvider.toLowerCase(),
          api_key: apiKey,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      console.log("✅ API Validation Success:", validateRes.data);

      /* ===============================
       2️⃣ STEP 2: SAVE OR UPDATE
    =============================== */
      const payload = {
        provider_name: selectedProvider,
        api_key: apiKey,
        enterprise_fid,
      };

      if (editingRecord) {
        // 🔁 UPDATE (only after validation success)
        await api.put(
          `${API_BASE}/enterprise-api-keys/${editingRecord.enterprise_api_key_setting_id}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        showSuccessToast(`${selectedProvider} API Key Updated Successfully ✔`);
      } else {
        // ➕ CREATE
        await api.post(`${API_BASE}/enterprise-api-keys`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });

        showSuccessToast(`${selectedProvider} API Key Added Successfully ✔`);
      }

      /* ===============================
       3️⃣ FINAL SUCCESS CLEANUP
    =============================== */
      fetchApiKeys(); // refresh table
      setShowApiModal(false); // close modal
      setApiKey(""); // clear input
      setEditingRecord(null); // reset edit state
    } catch (error) {
      console.error("❌ API validation or save failed:", error);

      const msg =
        error.response?.data?.message ||
        error.response?.data?.detail ||
        "API validation or save failed!";

      // 🔒 IMPORTANT:
      // We DO NOT clear apiKey
      // We DO NOT close modal
      // Old key remains safe in DB
      showErrorToast(msg);
    } finally {
      setIsValidating(false);
    }
  };

  const maskApiKey = (key) => {
    if (!key) return "—";

    const visibleStart = 4; // show first 4 chars
    const visibleEnd = 4; // show last 4 chars

    if (key.length <= visibleStart + visibleEnd) return key; // short keys, show fully

    const maskedMiddle = "*".repeat(key.length - visibleStart - visibleEnd);
    return key.slice(0, visibleStart) + maskedMiddle + key.slice(-visibleEnd);
  };

  const handleEdit = (row) => {
    // Store full record for update flow
    setEditingRecord(row);

    // Provider is fixed during update (disabled in modal)
    setSelectedProvider(row.provider_name);

    // 🔐 Never prefill API key for security
    setApiKey("");

    // Open modal
    setShowApiModal(true);
  };

  const handleChangeStatus = async (row) => {
    try {
      const newStatus = row.enterprise_api_key_status === "1" ? "0" : "1";

      await api.patch(
        `${API_BASE}/enterprise-api-keys/${row.enterprise_api_key_setting_id}/status`,
        { status: newStatus },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      showSuccessToast(
        `API Key ${
          newStatus === "1" ? "Activated" : "Deactivated"
        } Successfully`,
      );

      fetchApiKeys(); // refresh table
    } catch (error) {
      console.error("Failed to change API key status:", error);

      showErrorToast(
        error.response?.data?.message || "Failed to update status",
      );
    }
  };

  // 🔹 Delete API Key (hard delete)
  const handleDeleteApiKey = async (record) => {
    if (!record) return;

    const confirmDelete = window.confirm(
      `Are you sure you want to permanently delete the API key for ${record.provider_name}?`,
    );
    if (!confirmDelete) return;

    try {
      const provider = record.provider_name.toLowerCase();

      // 1️⃣ Find all ONLINE models related to this provider
      const providerModelNames = availableModels
        .filter(
          (m) =>
            m.model_details?.model_type === "Online" &&
            (m.model_details?.model_provider || "").toLowerCase() === provider,
        )
        .map((m) => m.model_fid.toLowerCase());

      // 2️⃣ Update state (uncheck models)
      setModelSettings((prev) => {
        const updatedModels = prev.recommended_models.filter(
          (m) => !providerModelNames.includes(m.toLowerCase()),
        );

        return {
          ...prev,
          recommended_models: updatedModels,
        };
      });

      // 3️⃣ Delete API key
      await api.delete(
        `${API_BASE}/enterprise-api-keys/${record.enterprise_api_key_setting_id}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      showSuccessToast("API Key deleted successfully ✔");
      fetchApiKeys();

      // 4️⃣ AUTO-SAVE AFTER STATE UPDATE
      // setTimeout(() => {
      //   handleSave(); // ✅ uses updated recommended_models
      // }, 0);
    } catch (error) {
      console.error("Failed to delete API key:", error);
      showErrorToast(
        error.response?.data?.message || "Failed to delete API key",
      );
    }
  };

  // 🔹 Delete API Key (hard delete only)
  // const handleDeleteApiKey = async (record) => {
  //   if (!record) return;

  //   const confirmDelete = window.confirm(
  //     `Are you sure you want to permanently delete the API key for ${record.provider_name}?`
  //   );
  //   if (!confirmDelete) return;

  //   try {
  //     await api.delete(
  //       `${API_BASE}/enterprise-api-keys/${record.enterprise_api_key_setting_id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     showSuccessToast("API Key deleted successfully ✔");

  //     // Refresh API key list
  //     fetchApiKeys();
  //   } catch (error) {
  //     console.error("Failed to delete API key:", error);
  //     showErrorToast(
  //       error.response?.data?.message || "Failed to delete API key"
  //     );
  //   }
  // };

  // 🔹 Copy API Key
  const handleCopyApiKey = (key) => {
    if (!key) return;
    navigator.clipboard
      .writeText(key)
      .then(() => {
        showSuccessToast("API Key copied to clipboard ✔");
      })
      .catch((err) => {
        console.error("Failed to copy API key:", err);
        showErrorToast("Failed to copy API key");
      });
  };

  // 🔹 Mask API Key (for table display)
  // const maskApiKey = (key) => {
  //   if (!key) return "—";
  //   const visibleStart = 4;
  //   const visibleEnd = 4;
  //   if (key.length <= visibleStart + visibleEnd) return key;
  //   const maskedMiddle = "*".repeat(key.length - visibleStart - visibleEnd);
  //   return key.slice(0, visibleStart) + maskedMiddle + key.slice(-visibleEnd);
  // };

  const providersWithModels = React.useMemo(() => {
    return [
      ...new Set(
        availableModels
          .filter(
            (m) => m.model_details?.model_type?.toLowerCase() === "online",
          )
          .map((m) => m.model_details?.model_provider?.toLowerCase())
          .filter(Boolean),
      ),
    ];
  }, [availableModels]);

  console.log("providersWithModels:", providersWithModels);

  return (
    <div className="py-2 px-3 h-100 overflow-y-auto">
      <div className="">
        {/* === Subscription === */}
        <div
          className="section-header d-flex align-items-center gap-2 mb-2"
          style={{ cursor: "pointer" }}
          onClick={() => setShowSubscription(!showSubscription)}
        >
          <div className="d-flex align-items-center">
            <div className="section-badge me-2">1</div>
            <h5 className="section-title mb-0">Subscription Details</h5>
          </div>
          <i
            className={`bi ${
              showSubscription ? "bi-caret-up-fill" : "bi-caret-down-fill"
            }`}
          ></i>
        </div>
        {showSubscription && (
          <>
            <div className="row mb-3">
              <div className="col-md-4">
                <label>Subscription Name</label>
                <select
                  className="form-select"
                  value={subscription.enterprise_subscription_name}
                  onChange={handleInput(
                    setSubscription,
                    "enterprise_subscription_name",
                  )}
                >
                  <option value="">Select Subscription</option>
                  <option value="basic">Basic</option>
                  <option value="standard">Standard</option>
                  <option value="premium">Premium</option>
                </select>
              </div>
              <div className="col-md-4">
                <label>Subscription Duration</label>
                <input
                  type="text"
                  className="form-control"
                  value={subscription.enterprise_subscription_duration}
                  onChange={handleInput(
                    setSubscription,
                    "enterprise_subscription_duration",
                  )}
                />
              </div>
              <div className="col-md-4">
                <label>Subscription Price</label>
                <input
                  type="text"
                  className="form-control"
                  value={subscription.enterprise_subscription_prize}
                  onChange={handleInput(
                    setSubscription,
                    "enterprise_subscription_prize",
                  )}
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4">
                <label>Subscription Start Date</label>
                <DatePicker
                  className="datecolor"
                  calendarClassName="datecolor" // calendar popup
                  selected={
                    subscription.enterprise_subscription_start_date
                      ? new Date(
                          subscription.enterprise_subscription_start_date,
                        )
                      : null
                  }
                  onChange={(date) => {
                    const iso = date?.toISOString().split("T")[0];
                    setSubscription((prev) => ({
                      ...prev,
                      enterprise_subscription_start_date: iso,
                      enterprise_subscription_end_date:
                        prev.enterprise_subscription_end_date < iso
                          ? ""
                          : prev.enterprise_subscription_end_date,
                    }));
                  }}
                  dateFormat="MM/dd/yyyy"
                  minDate={new Date()}
                  customInput={<CustomDateInput />}
                />
              </div>

              <div className="col-md-4">
                <label>Subscription End Date</label>
                <DatePicker
                  selected={
                    subscription.enterprise_subscription_end_date
                      ? new Date(subscription.enterprise_subscription_end_date)
                      : null
                  }
                  onChange={(date) => {
                    const iso = date?.toISOString().split("T")[0];
                    setSubscription((prev) => ({
                      ...prev,
                      enterprise_subscription_end_date: iso,
                    }));
                  }}
                  dateFormat="MM/dd/yyyy"
                  minDate={
                    subscription.enterprise_subscription_start_date
                      ? new Date(
                          subscription.enterprise_subscription_start_date,
                        )
                      : new Date()
                  }
                  customInput={<CustomDateInput />}
                />
              </div>
            </div>
          </>
        )}

        {/* === Organization === */}
        <div
          className="section-header d-flex align-items-center gap-2 mb-2"
          style={{ cursor: "pointer" }}
          onClick={() => setShowOrganization(!showOrganization)}
        >
          <div className="d-flex align-items-center">
            <div className="section-badge me-2">2</div>
            <h5 className="section-title mb-0">Organization Settings</h5>
          </div>
          <i
            className={`bi ${
              showOrganization ? "bi-caret-up-fill" : "bi-caret-down-fill"
            }`}
          ></i>
        </div>
        {showOrganization && (
          <>
            <div className="row mb-3">
              <div className="col-md-4">
                <label>Theme</label>
                <select
                  className="form-select"
                  value={organization.enterprise_organisation_settings_theme}
                  onChange={handleInput(
                    setOrganization,
                    "enterprise_organisation_settings_theme",
                  )}
                >
                  <option value="">Select Theme</option>
                  <option value="light">Light</option>
                  <option value="dark">Dark</option>
                  <option value="custom">Custom</option>
                </select>
              </div>
              <div className="col-md-4">
                <label>Select Model</label>
                <select
                  className="form-select"
                  value={
                    organization.enterprise_organisation_settings_selected_model
                  }
                  onChange={handleInput(
                    setOrganization,
                    "enterprise_organisation_settings_selected_model",
                  )}
                >
                  <option value="">Choose Model</option>
                  <option value="gpt-3.5">GPT-3.5</option>
                  <option value="gpt-4">GPT-4</option>
                  <option value="custom">Custom Model</option>
                </select>
              </div>
              <div className="col-md-4">
                <label>Training Frequency</label>
                <select
                  className="form-select"
                  value={organization.training_frequency}
                  onChange={handleInput(setOrganization, "training_frequency")}
                >
                  <option value="">Select Frequency</option>
                  <option value="daily">Daily</option>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                </select>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-4">
                <label>No Need To Store Data</label>
                <select
                  className="form-select"
                  value={organization.data_retention_period}
                  onChange={handleInput(
                    setOrganization,
                    "data_retention_period",
                  )}
                >
                  <option value="">Select Duration</option>
                  <option value="30">30 Days</option>
                  <option value="90">90 Days</option>
                </select>
              </div>
              <div className="col-md-4">
                <label>Total Allowed Document Size</label>
                <select
                  className="form-select"
                  value={organization.allowed_doc_size_mb}
                  onChange={handleInput(setOrganization, "allowed_doc_size_mb")}
                >
                  <option value="">Select Size</option>
                  <option value="100">100 MB</option>
                  <option value="500">500 MB</option>
                  <option value="1024">1 GB</option>
                </select>
              </div>
            </div>

            <div className="row mb-4"></div>
          </>
        )}

        {/* === Model Settings === */}
        <div
          className="section-header d-flex align-items-center gap-2 mb-3"
          style={{ cursor: "pointer" }}
          onClick={() => setShowModelSettings(!showModelSettings)}
        >
          <div className="d-flex align-items-center">
            <div className="section-badge me-2">3</div>
            <h5 className="section-title mb-0">Model Settings</h5>
          </div>
          <i
            className={`bi ${
              showModelSettings ? "bi-caret-up-fill" : "bi-caret-down-fill"
            }`}
          ></i>
        </div>
        {showModelSettings && (
          <div className="mb-3">
            <h6 className="d-flex align-items-center">
              <img
                src={recommandedIcon}
                alt="Recommended Icon"
                style={{ width: "25px", height: "28px" }}
                className="me-2"
              />
              Recommended Models
            </h6>

            <div className="fw-bold mt-2 mb-2 refresh-prompts">
              OFFLINE MODELS
            </div>

            <div className="row mx-2 mb-3">
              {availableModels.filter(
                (m) => m.model_details?.model_type === "Offline",
              ).length === 0 ? (
                <div className="col-12 refresh-prompts fst-italic">
                  No offline models found. Please add or download an offline
                  model to continue.
                </div>
              ) : (
                availableModels
                  .filter((m) => m.model_details?.model_type === "Offline")
                  .map((model) => {
                    const modelName = model.model_fid;

                    const isChecked = modelSettings.recommended_models
                      ?.map((m) => m.toLowerCase())
                      .includes(modelName.toLowerCase());

                    return (
                      <div className="col-md-3 mb-2" key={modelName}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={isChecked}
                            onChange={(e) => {
                              const updated = e.target.checked
                                ? [
                                    ...modelSettings.recommended_models,
                                    modelName,
                                  ]
                                : modelSettings.recommended_models.filter(
                                    (m) =>
                                      m.toLowerCase() !==
                                      modelName.toLowerCase(),
                                  );

                              setModelSettings((prev) => ({
                                ...prev,
                                recommended_models: updated,
                              }));
                            }}
                          />
                          <label className="ms-2 form-check-label">
                            {model.model_details?.model_generic_name ||
                              modelName}
                          </label>
                        </div>
                      </div>
                    );
                  })
              )}
            </div>

            <button
              className="custom-btn mt-2 mb-2 d-flex align-items-center gap-2"
              onClick={() => setShowApiModal(true)}
            >
              <img
                src={addIcon}
                alt="plus icon"
                style={{ width: "18px", height: "18px" }}
                className="icon-image"
              />
              Add API Key
            </button>

            <div className="table-responsive">
              <table className="table  mt-2 table-sm w-100">
                <thead>
                  <tr>
                    <th>Provider</th>
                    <th>API Key</th>
                    <th>Online Models</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {apiKeys.length > 0 ? (
                    apiKeys.map((k) => {
                      const provider = k.provider_name.toLowerCase();

                      const providerModels = availableModels.filter(
                        (m) =>
                          m.model_details?.model_type === "Online" &&
                          (
                            m.model_details?.model_provider || ""
                          ).toLowerCase() === provider,
                      );

                      const hasApiKey = Boolean(k.api_key);

                      return (
                        <tr key={k.enterprise_api_key_setting_id}>
                          <td className="fw-semibold">{k.provider_name}</td>

                          <td
                            style={{
                              maxWidth: "150px", 
                              overflow: "hidden",
                              textOverflow: "clip",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {maskApiKey(k.api_key)}
                          </td>

                          <td>
                            <div className="d-flex flex-wrap">
                              {providerModels.length > 0 ? (
                                providerModels.map((model) => {
                                  const modelName = model.model_fid;

                                  const isChecked =
                                    modelSettings.recommended_models
                                      ?.map((m) => m.toLowerCase())
                                      .includes(modelName.toLowerCase());

                                  return (
                                    <div
                                      className="form-check me-3 align-items-center d-flex"
                                      key={modelName}
                                    >
                                      <input
                                        type="checkbox"
                                        className="custom-checkbox"
                                        disabled={!hasApiKey}
                                        checked={hasApiKey && isChecked}
                                        onChange={(e) => {
                                          if (!hasApiKey) return;

                                          const updated = e.target.checked
                                            ? [
                                                ...modelSettings.recommended_models,
                                                modelName,
                                              ]
                                            : modelSettings.recommended_models.filter(
                                                (m) =>
                                                  m.toLowerCase() !==
                                                  modelName.toLowerCase(),
                                              );

                                          setModelSettings((prev) => ({
                                            ...prev,
                                            recommended_models: updated,
                                          }));
                                        }}
                                      />
                                      <label
                                        className={`ms-1 form-check-label ${
                                          !hasApiKey ? "refresh-prompts" : ""
                                        }`}
                                      >
                                        {model.model_details
                                          ?.model_generic_name || modelName}
                                      </label>
                                    </div>
                                  );
                                })
                              ) : (
                                <span className="refresh-prompts">No models</span>
                              )}
                            </div>
                          </td>

                          <td className="gap-2">
                            <button
                              className="icon-button"
                              onClick={() => handleCopyApiKey(k.api_key)}
                              title="Copy API Key"
                            >
                              <img
                                src={cpyIcon}
                                className="icon-image"
                                alt="Copy"
                              />
                            </button>

                            <button
                              className="icon-button"
                              onClick={() => handleEdit(k)}
                              title="Edit"
                            >
                              <img
                                src={editIcon}
                                className="icon-image"
                                alt="Edit"
                              />
                            </button>

                            <button
                              className="icon-button"
                              onClick={() => handleDeleteApiKey(k)}
                              title="Delete"
                            >
                              <img
                                src={crossIcon}
                                className="icon-image"
                                alt="Delete"
                              />
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center refresh-prompts">
                        No API keys found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* === Documentation Settings === */}
        <div
          className="section-header d-flex align-items-center gap-2 mb-2"
          style={{ cursor: "pointer" }}
          onClick={() => setShowDocumentation(!showDocumentation)}
        >
          <div className="d-flex align-items-center">
            <div className="section-badge me-2">4</div>
            <h5 className="section-title mb-0">Documentation Settings</h5>
          </div>
          <i
            className={`bi ${
              showDocumentation ? "bi-caret-up-fill" : "bi-caret-down-fill"
            }`}
          ></i>
        </div>

        {showDocumentation && (
          <div className="row mb-4">
            <div className="col-md-4 d-flex align-items-center">
              <label className="me-3 mb-0">Auto Approve</label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={documentation.auto_approve || false}
                  onChange={(e) =>
                    setDocumentation((prev) => ({
                      ...prev,
                      auto_approve: e.target.checked,
                    }))
                  }
                />
              </div>
            </div>
          </div>
        )}

        {/* === Template Setting === */}
        <div
          className="section-header d-flex align-items-center gap-2 mb-2"
          style={{ cursor: "pointer" }}
          onClick={() => setShowTemplateSettings(!showTemplateSettings)}
        >
          <div className="d-flex align-items-center">
            <div className="section-badge me-2">5</div>
            <h5 className="section-title mb-0">Template Setting</h5>
          </div>
          <i
            className={`bi ${
              showTemplateSettings ? "bi-caret-up-fill" : "bi-caret-down-fill"
            }`}
          ></i>
        </div>

        {showTemplateSettings && (
          <div className="theme-settings-container p-4 mb-4 border rounded shadow-sm" style={{ position: 'relative' }}>
            {isLoadingTheme && (
              <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75 rounded" style={{ zIndex: 10 }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
            {/* Template Selection */}
            <h6 className="mb-3 refresh-prompts fw-bold border-bottom pb-2">
              <i className="bi bi-layout-text-window-reverse me-2"></i>
              Choose Template
            </h6>
            <div className="row g-3 mb-4">
              {colorTemplates.map((template) => (
                <div
                  className="col-md-2"
                  key={template.id}
                  style={{ flex: "0 0 auto", width: "20%" }}
                >
                  <div
                    className={`template-card p-2 border rounded text-center cursor-pointer h-100 ${selectedTemplate === template.id ? "border-primary border-2 shadow-sm" : "border-light-subtle"}`}
                    onClick={() => {
                      setSelectedTemplate(template.id);
                      setThemeSettings((prev) => ({
                        ...prev,
                        ...template.colors,
                      }));
                    }}
                    style={{ cursor: "pointer", transition: "all 0.2s ease" }}
                  >
                    <div className="d-flex gap-1 mb-2 justify-content-center">
                      <div
                        style={{
                          width: "18px",
                          height: "18px",
                          backgroundColor: template.colors.header_color,
                          borderRadius: "4px",
                          border: "1px solid rgba(0,0,0,0.1)",
                        }}
                      ></div>
                      <div
                        style={{
                          width: "18px",
                          height: "18px",
                          backgroundColor: template.colors.accent_color,
                          borderRadius: "4px",
                          border: "1px solid rgba(0,0,0,0.1)",
                        }}
                      ></div>
                      <div
                        style={{
                          width: "18px",
                          height: "18px",
                          backgroundColor: template.colors.slide_background,
                          borderRadius: "4px",
                          border: "1px solid rgba(0,0,0,0.1)",
                        }}
                      ></div>
                    </div>
                    <small
                      className={`fw-bold ${selectedTemplate === template.id ? "text-primary" : "refresh-prompts"}`}
                    >
                      {template.name}
                    </small>
                  </div>
                </div>
              ))}
            </div>

            {/* Basic Info & Logo */}
            <div className="row mb-4 align-items-center">
              {/* <div className="col-md-4">
                <label className="fw-bold mb-1">Enterprise Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={themeSettings.enterprise_name}
                  onChange={handleInput(setThemeSettings, "enterprise_name")}
                  placeholder="Enter Enterprise Name"
                />
              </div> */}
              <div className="col-md-7">
                <label className="fw-bold mb-1">
                  Brand Logo (Landscape Only)
                </label>
                <div
                  className="d-flex align-items-center gap-3 border p-3 rounded bg-light-custom"
                  style={{ minHeight: "80px" }}
                >
                  <div
                    className="logo-preview-box border rounded d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "140px",
                      height: "60px",
                      overflow: "hidden",
                    }}
                  >
                    {logoPreviewUrl ? (
                      <img
                        src={logoPreviewUrl}
                        alt="Logo"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <div className="text-center">
                        <i
                          className="bi bi-image refresh-prompts"
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                        <div
                          style={{ fontSize: "10px" }}
                          className="refresh-prompts"
                        >
                          No Logo
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="d-flex flex-column gap-2 flex-grow-1">
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                        onClick={() =>
                          document.getElementById("logoUploadInput").click()
                        }
                      >
                        <i className="bi bi-upload"></i>Upload
                      </button>
                      <button
                        type="button"
                        className="btn refresh-prompts d-flex align-items-center gap-1"
                        onClick={() => {
                          setLogoFile(null);
                          setLogoPreviewUrl(null);
                          setThemeSettings((prev) => ({
                            ...prev,
                            logo_path: "",
                            logo_key: "",
                          }));
                        }}
                        disabled={!logoPreviewUrl}
                      >
                        <i className="bi bi-trash"></i>Remove
                      </button>
                    </div>
                    <input
                      id="logoUploadInput"
                      type="file"
                      className="d-none"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setLogoFile(file);
                          setLogoPreviewUrl(URL.createObjectURL(file));
                          setShowCropModal(true);
                        }
                      }}
                    />
                    <div className="refresh-prompts" style={{ fontSize: "11px" }}>
                      <i className="bi bi-info-circle me-1"></i>
                      Supports JPG, PNG, SVG (Max 2MB)
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 d-flex align-items-center justify-content-end">
                <div className="form-check form-switch custom-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="enableLogo"
                    checked={themeSettings.enable_logo}
                    onChange={(e) =>
                      setThemeSettings((prev) => ({
                        ...prev,
                        enable_logo: e.target.checked,
                      }))
                    }
                    style={{ width: "2.5rem", height: "1.25rem" }}
                  />
                  <label
                    className="form-check-label fw-bold ms-2"
                    htmlFor="enableLogo"
                  >
                    Enable Branding
                  </label>
                </div>
              </div>
            </div>

            {/* Colors Grid */}
            <h6 className="mt-4 mb-3 refresh-prompts fw-bold border-bottom pb-2">
              <i className="bi bi-palette me-2"></i>Theme Colors
            </h6>
            <div className="row g-3">
              {[
                { label: "Slide Background", key: "slide_background" },
                { label: "Header Color", key: "header_color" },
                { label: "Accent Color", key: "accent_color" },
                { label: "NA Yellow", key: "na_yellow" },
                { label: "White", key: "white" },
                { label: "Light BG", key: "light_bg" },
              ].map((item) => (
                <div className="col-md-4" key={item.key}>
                  <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                    <label className="mb-0 small fw-semibold">
                      {item.label}
                    </label>
                    <input
                      type="color"
                      className="form-control form-control-color border-0 p-0"
                      value={themeSettings[item.key]}
                      onChange={(e) =>
                        setThemeSettings((prev) => ({
                          ...prev,
                          [item.key]: e.target.value,
                        }))
                      }
                      title={`Choose ${item.label}`}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Right Card Colors */}
            <h6 className="mt-4 mb-3 refresh-prompts fw-bold border-bottom pb-2">
              <i className="bi bi-card-text me-2"></i>Right Card Settings
            </h6>
            <div className="row g-3">
              {[
                { label: "Card BG", key: "right_card_bg" },
                { label: "Row Odd", key: "right_card_row_odd" },
                { label: "Row Even", key: "right_card_row_even" },
                { label: "Title Color", key: "right_card_title_clr" },
                { label: "Label Color", key: "right_card_label_clr" },
                { label: "Value Color", key: "right_card_value_clr" },
                { label: "Link Color", key: "right_card_link_clr" },
              ].map((item) => (
                <div className="col-md-3" key={item.key}>
                  <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                    <label className="mb-0 small fw-semibold">
                      {item.label}
                    </label>
                    <input
                      type="color"
                      className="form-control form-control-color border-0 p-0"
                      value={themeSettings[item.key]}
                      onChange={(e) =>
                        setThemeSettings((prev) => ({
                          ...prev,
                          [item.key]: e.target.value,
                        }))
                      }
                      title={`Choose ${item.label}`}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Text & Navy Colors */}
            <h6 className="mt-4 mb-3 refresh-prompts fw-bold border-bottom pb-2">
              <i className="bi bi-fonts me-2"></i>Text & Branding Colors
            </h6>
            <div className="row g-3">
              {[
                { label: "Text Dark", key: "text_dark" },
                { label: "Text Mid", key: "text_mid" },
                { label: "Text Gray", key: "text_gray" },
                { label: "Blue Link", key: "blue_link" },
                { label: "Navy", key: "navy" },
                { label: "Navy Mid", key: "navy_mid" },
                { label: "Navy Light", key: "navy_light" },
                { label: "Custom Blue", key: "custom_blue" },
              ].map((item) => (
                <div className="col-md-3" key={item.key}>
                  <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                    <label className="mb-0 small fw-semibold">
                      {item.label}
                    </label>
                    <input
                      type="color"
                      className="form-control form-control-color border-0 p-0"
                      value={themeSettings[item.key]}
                      onChange={(e) =>
                        setThemeSettings((prev) => ({
                          ...prev,
                          [item.key]: e.target.value,
                        }))
                      }
                      title={`Choose ${item.label}`}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Fonts & Footer */}
            <h6 className="mt-4 mb-3 refresh-prompts fw-bold border-bottom pb-2">
              <i className="bi bi-textarea-t me-2"></i>Typography & Footer
            </h6>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="fw-semibold small">Primary Font</label>
                <select
                  className="form-select"
                  value={themeSettings.primary_font}
                  onChange={handleInput(setThemeSettings, "primary_font")}
                >
                  <option value="Calibri">Calibri</option>
                  <option value="Arial">Arial</option>
                  <option value="Roboto">Roboto</option>
                  <option value="Inter">Inter</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="fw-semibold small">Header Font</label>
                <select
                  className="form-select"
                  value={themeSettings.header_font}
                  onChange={handleInput(setThemeSettings, "header_font")}
                >
                  <option value="Calibri">Calibri</option>
                  <option value="Arial">Arial</option>
                  <option value="Roboto">Roboto</option>
                  <option value="Inter">Inter</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="fw-semibold small">Footer Font</label>
                <select
                  className="form-select"
                  value={themeSettings.footer_font}
                  onChange={handleInput(setThemeSettings, "footer_font")}
                >
                  <option value="Calibri">Calibri</option>
                  <option value="Arial">Arial</option>
                  <option value="Roboto">Roboto</option>
                  <option value="Inter">Inter</option>
                </select>
              </div>
              <div className="col-md-2">
                <label className="fw-semibold small">Footer Font Size</label>
                <input
                  type="number"
                  className="form-control"
                  value={themeSettings.footer_font_size}
                  onChange={(e) =>
                    setThemeSettings((prev) => ({
                      ...prev,
                      footer_font_size: parseInt(e.target.value) || 0,
                    }))
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="fw-semibold small">Confidential Text</label>
                <input
                  type="text"
                  className="form-control"
                  value={themeSettings.confidential_text}
                  onChange={handleInput(setThemeSettings, "confidential_text")}
                />
              </div>
              <div className="col-md-2 d-flex align-items-center mt-4">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="enableFooter"
                    checked={themeSettings.enable_footer}
                    onChange={(e) =>
                      setThemeSettings((prev) => ({
                        ...prev,
                        enable_footer: e.target.checked,
                      }))
                    }
                  />
                  <label
                    className="form-check-label fw-bold small"
                    htmlFor="enableFooter"
                  >
                    Enable Footer
                  </label>
                </div>
              </div>
              <div className="col-md-2 d-flex align-items-center mt-4">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="enableConfidential"
                    checked={themeSettings.enable_confidential}
                    onChange={(e) =>
                      setThemeSettings((prev) => ({
                        ...prev,
                        enable_confidential: e.target.checked,
                      }))
                    }
                  />
                  <label
                    className="form-check-label fw-bold small"
                    htmlFor="enableConfidential"
                  >
                    Enable Confidential
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}

        <hr className="my-4" />

        <div className="d-flex justify-content-center gap-2">
          <button
            type="button"
            className="cancle-btn"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleReset}
          >
            Reset to Default
          </button>
          <button type="button" className="custom-btn" onClick={handleSave} disabled={isSaving}>
            {isSaving ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Saving...
              </>
            ) : "Save Configuration"}
          </button>
        </div>
        {/* <hr className="mt-5" /> */}
      </div>

      {showApiModal && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-history modal-dialog-centered history-model">
            <div className="modal-content position-relative">
              {/* ❌ Close Button */}
              <button
                type="button"
                className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
                onClick={() => {
                  setShowApiModal(false);
                  setEditingRecord(null);
                  setApiKey("");
                  setSelectedProvider("OpenAI");
                }}
              >
                <img
                  src={crossIcon}
                  className="icon-image cross-i"
                  alt="Close"
                />
              </button>

              {/* -------- Modal Body -------- */}
              <div className="p-4">
                <p className="fw-bold text-center mt-2 mb-4 refresh-prompts">
                  {editingRecord ? "Update API Key" : "Add API Key"}
                </p>

                {/* 🔽 Provider Select */}
                <label className="fw-semibold mb-1">Select Provider</label>
                <select
                  className="form-select mb-3"
                  value={selectedProvider}
                  onChange={(e) => setSelectedProvider(e.target.value)}
                  disabled={!!editingRecord}
                >
                  {providersWithModels.map((provider) => (
                    <option key={provider} value={provider}>
                      {provider}
                    </option>
                  ))}
                </select>

                {/* 🔑 API Key Input */}
                <label className="fw-semibold mb-1">
                  {editingRecord ? "New API Key" : "API Key"}
                </label>

                <textarea
                  className="form-control"
                  rows="3"
                  placeholder={
                    editingRecord
                      ? "Paste new API key to replace existing one..."
                      : "Paste your API key here..."
                  }
                  value={apiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                />

                {editingRecord && (
                  <small className="refresh-prompts d-block mt-1">
                    Existing API key will remain unchanged if validation or
                    update fails.
                  </small>
                )}
              </div>

              {/* -------- Footer Buttons -------- */}
              <div className="modal-footer justify-content-center gap-2 mb-3">
                <button
                  type="button"
                  className="px-5 rounded cancle-btn border-none py-2 fw-bold"
                  onClick={() => {
                    setShowApiModal(false);
                    setEditingRecord(null);
                    setApiKey("");
                    setSelectedProvider("OpenAI");
                  }}
                  disabled={isValidating}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="px-5 rounded custom-btn border-none py-2 fw-bold history-btn"
                  onClick={handleValidateApi}
                  disabled={isValidating}
                >
                  {isValidating
                    ? "Validating..."
                    : editingRecord
                      ? "Validate & Update"
                      : "Validate & Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 🖼️ Logo Adjustment Modal */}
      {showCropModal && (
        <div
          className="modal modal-backdrop-custom d-block"
          tabIndex="-1"
          style={{ zIndex: 2000 }}
        >
          <div
            className="modal-history modal-dialog-centered"
            style={{ maxWidth: "800px" }}
          >
            <div className="modal-content">
              <div className="modal-header border-bottom p-3">
                <h5 className="modal-title fw-bold">Adjust Logo (Landscape)</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCropModal(false)}
                ></button>
              </div>
              <div className="modal-body p-0 text-center" style={{ position: 'relative', height: '400px', background: '#333' }}>
                <Cropper
                  image={logoPreviewUrl}
                  crop={crop}
                  zoom={zoom}
                  aspect={4 / 1}
                  onCropChange={setCrop}
                  onCropComplete={(croppedArea, croppedAreaPixels) => setCroppedAreaPixels(croppedAreaPixels)}
                  onZoomChange={setZoom}
                />
              </div>
              <div className="modal-footer flex-column p-3">
                <div className="w-100 mb-3 px-4">
                  <label className="form-label d-flex justify-content-between small fw-bold text-muted">
                    <span>Zoom Level</span>
                    <span>{Math.round(zoom * 100)}%</span>
                  </label>
                  <input
                    type="range"
                    value={zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    aria-labelledby="Zoom"
                    onChange={(e) => setZoom(e.target.value)}
                    className="form-range"
                  />
                </div>
                <div className="d-flex justify-content-center gap-2 w-100">
                  <button
                    type="button"
                    className="btn cancle-btn px-4"
                    onClick={() => {
                      setLogoFile(null);
                      setLogoPreviewUrl(null);
                      setShowCropModal(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn custom-btn px-4"
                    disabled={isProcessingLogo}
                    onClick={async () => {
                      try {
                        setIsProcessingLogo(true);
                        const croppedImageBlob = await getCroppedImg(
                          logoPreviewUrl,
                          croppedAreaPixels
                        );
                        const croppedImageUrl = URL.createObjectURL(croppedImageBlob);
                        
                        // Update the file and preview with the cropped version
                        const file = new File([croppedImageBlob], "logo_cropped.png", { type: "image/png" });
                        setLogoFile(file);
                        setLogoPreviewUrl(croppedImageUrl);
                        setIsProcessingLogo(false);
                        setShowCropModal(false);
                        showSuccessToast("Logo adjusted successfully");
                      } catch (e) {
                        setIsProcessingLogo(false);
                        console.error(e);
                        showErrorToast("Failed to crop image");
                      }
                    }}
                  >
                    {isProcessingLogo ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Processing...
                      </>
                    ) : "Confirm & Crop"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EnterpriseSettings;
